let counter = 0;

/**
 * Generate a stable-ish unique id for client-side entities (rows, instances,
 * dep ties, etc.). Not cryptographic — just collision-free for the lifetime
 * of the page.
 */
export function makeId(prefix: string): string {
  counter += 1;
  return `${prefix}-${Date.now().toString(36)}-${counter}`;
}
